<template>
  <v-dialog v-model="dialog" persistent width="780px">
    <v-card>
      <v-card-title class="headline">
        <v-icon>check</v-icon> Aprobar permiso
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="py-0">
        <v-container grid-list-md class="p-0" style="min-width: 100%;">
          <v-layout row wrap>
            <v-flex xs12>
              <span class="texto-aprobar"
                ><b>Número:</b> {{ permiso.numero }}</span
              >
            </v-flex>
            <v-flex xs12>
              <span class="texto-aprobar"
                ><b>Funcionario:</b> {{ permiso.nombres }}</span
              >
            </v-flex>
            <v-flex xs12>
              <span class="texto-aprobar">
                <b>Tipo de papeleta:</b> {{ permiso.tipo_permiso }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == 8">
              <span class="texto-aprobar">
                <b>Lugar de atencion:</b> {{ permiso.lugar_atencion }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == 87">
              <span class="texto-aprobar"
                ><b>Lugar de comisión :</b> {{ permiso.lugar }}</span
              >
            </v-flex>
            <v-flex
              xs12
              v-if="
                permiso.id_tipo_permiso == 87 || 
                permiso.id_tipo_permiso == 104 ||
                permiso.id_tipo_permiso == 96
              "
            >
              <span class="texto-aprobar"
                ><b>Motivo:</b> {{ permiso.motivo }}</span
              >
              <!-- <span class="texto-aprobar"><b>Motivo:</b> {{ permiso_detalles2[0].permiso.motivo }}</span> -->
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == 90">
              <span class="texto-aprobar"
                ><b>Tipo de baja:</b> {{ permiso.motivo }}</span
              >
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '61'">
              <span class="texto-aprobar">
                <b>Fecha de nacimiento:</b>
                {{ permiso.fecha_nac_muerte }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '61'">
              <span class="texto-aprobar">
                <b>Hora de nacimiento:</b>
                {{ permiso.hora_nac_muerte }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '6'">
              <span class="texto-aprobar">
                <b>Fecha de fallecimiento:</b>
                {{ permiso.fecha_nac_muerte }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '6'">
              <span class="texto-aprobar">
                <b>Hora de fallecimiento:</b>
                {{ permiso.hora_nac_muerte }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '12'">
              <span class="texto-aprobar">
                <b>Fecha de matrimonio:</b>
                {{ $moment(permiso.fecha_nac_muerte).format("DD-MM-YY") }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == 44">
              <span class="texto-aprobar">
                <b>Condición o estado crítico de salud :</b>
                {{ permiso.permiso.motivo }}
              </span>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <span class="subtitulo-aprobar"
                ><b>Detalles de papeleta.</b></span
              >
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <!-- permisos por horas -->
              <v-data-table
                :items="permiso_detalles2"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers_horas"
                v-if="
                  permiso.id_tipo_permiso == 87 ||
                  permiso.id_tipo_permiso == 104 ||
                    permiso.id_tipo_permiso == 96 ||
                    permiso.id_tipo_permiso == 88 ||
                    (permiso.id_tipo_permiso >= 37 &&
                      permiso.id_tipo_permiso <= 43)
                "
              >
                >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_retorno }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">{{ props.item.horas_permiso }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos por dias decimales -->
          <v-layout>
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles2"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers_dias_decimales"
                v-if="
                  permiso.id_tipo_permiso == 14 ||
                  permiso.id_tipo_permiso == 105 ||
                    (permiso.id_tipo_permiso >= 98 &&
                      permiso.id_tipo_permiso <= 101) ||
                    permiso.id_tipo_permiso == 89 ||
                    permiso.id_tipo_permiso == 18
                "
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_retorno }}
                  </td>

                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">{{ props.item.nro_dias }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos por dias completos-->
          <v-layout>
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles2"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers_dias"
                v-if="
                  permiso.id_tipo_permiso == 6 ||
                    permiso.id_tipo_permiso == 44 ||
                    permiso.id_tipo_permiso == 95 ||
                    permiso.id_tipo_permiso == 61 ||
                    permiso.id_tipo_permiso == 12 ||
                    permiso.id_tipo_permiso == 90
                "
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_retorno }}
                  </td>
                  <td class="text-xs-center">{{ props.item.nro_dias }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos 94 formulario de registro de asistencias-->
          <v-layout v-if="permiso.id_tipo_permiso == 94">
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles2"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers_registro_asistencias"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_retorno }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!--permiso 24-->
          <v-layout>
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers"
                v-if="permiso.id_tipo_permiso == '24'"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td v-if="props.item.rango_horario == 1">Solo mañana</td>
                  <td v-if="props.item.rango_horario == 2">Solo tarde</td>
                  <td v-if="props.item.rango_horario == 0">Todo el día</td>
                  <td class="text-xs-center">{{ props.item.total_dias }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>

          <span
            v-if="
              permiso.id_tipo_permiso == 88 || permiso.id_tipo_permiso == 96
            "
            class="subtitulo-aprobar"
          >
            <b>Detalles compensacion</b>
          </span>
          <v-layout
            v-if="
              permiso.id_tipo_permiso == 88 || permiso.id_tipo_permiso == 96
            "
          >
            <v-flex xs12>
              <v-data-table
                :items="permiso_compensacion"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers2"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ $moment(props.item.fecha_desde).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">
                    {{ $moment(props.item.fecha_hasta).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">
                    {{ props.item.diferencia_horas }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-layout class="pa-2">
            <v-flex xs12>
              <span
                v-if="
                  permiso.id_tipo_permiso == 88 || permiso.id_tipo_permiso == 96
                "
                class="subtitulo-aprobar"
              >
                <b>Total horas: {{ total_horas_acomuladas }}</b>
              </span>
            </v-flex>
          </v-layout>
          <v-flex xs12>
            <span class="subtitulo-aprobar"
              ><b>Seguimiento de la papeleta</b></span
            >
          </v-flex>
          <v-layout>
            <v-flex xs12>
              <v-data-table
                :headers="headers_seg_detalle"
                :items="detalle_seguimiento"
                class="tabla-comprimida-light elevation-1"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ $moment(props.item._created_at).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.estado }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.usuario ? props.item.usuario : "" }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click.prevent="close()" :loading="loading"
          ><v-icon>close</v-icon>
          Cancelar
        </v-btn>
        <v-btn
          color="success"
          @click.prevent="apruebaRechazaPermiso(permiso, 7)"
          :loading="loading"
          ><v-icon>check</v-icon>
          Aprobar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";
import SeguimientoDetalle from "../components/SeguimientoDetalle";

export default {
  components: {
    SeguimientoDetalle
  },
  mixins: [validate],
  props: ["item"],
  async mounted() {
    this.$bus.$on("openDialogAprobarPermisoOficialPorHoras", item => {
      this.permiso = item;
      this.total_horas();
      this.cargarDetallesPermiso();
      this.verPermisosCompensacion(parseInt(this.permiso.id_permiso));
      this.permiso.motivo_rechazo = "";
      this.getDetallePermiso(parseInt(this.permiso.id_permiso));
      this.getDetalleSeguimiemto(parseInt(this.permiso.id_permiso));
      this.dialog = true;
    });
  },
  data() {
    return {
      dialog: false,
      permiso: {
        motivo_rechazo: ""
      },
      permiso_detalles2: [],
      permiso_compensacion: [],
      permiso_detalles: [],
      detalle_seguimiento: [],
      loading: false,
      horas_solicitadas_comp: 0,
      total_horas_acomuladas: 0,
      headers: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers_horas: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      headers_registro_asistencias: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        }
      ],
      headers_dias_decimales: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },

        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers_dias: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        // {
        // 	text: 'Hora desde',
        // 	sortable: false,
        // 	align: 'center'
        // },
        // {
        // 	text: 'Hora hasta',
        // 	sortable: false,
        // 	align: 'center'
        // },
        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers2: [
        {
          text: "Fecha desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      headers_seg_detalle: [
        // { text: 'Número', sortable: false, align: 'center'},
        { text: "Fecha de registro", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" },
        { text: "Usuario Registro", sortable: false, align: "center" }
      ],

      horas_solicitadas: 0
    };
  },
  methods: {
    // Envia correo al detinatario del permiso
    async enviarCorreoDestinatario(permiso) {
      let destinatario = await this.$service.obtieneDestinatarioPermiso(
        permiso.id_permiso
      );
      if (!destinatario) {
        return;
      }
      destinatario = JSON.parse(destinatario);
      var mensaje = "";
      var asunto = "";
      // Verificamos si se esta aprobando
      if (destinatario.id_persona == permiso.id_funcionario) {
        mensaje = `
            <h1>NOTIFICACIÓN APROBACIÓN DE PERMISO</h1>
            Estimado(a): ${destinatario.nombres}<br>El motivo de la presente es para informarle que se le APROBO un permiso con los siguientes datos:<br>
            <b>NOMBRE SOLICITANTE:</b>  <br>${permiso.nombres}<br>
            <b>TIPO DE PERMISO:</b>  <br>${permiso.tipo_permiso}<br>
            <b>NRO PAPELETA:</b>  <br>${permiso.numero}<br>
            <b>FECHA DE SOLICITUD:</b>  <br>${permiso.fecha_emision}<br>
            <b>FECHA SALIDA - FIN:</b>  <br>${permiso.fecha_desde} - ${permiso.fecha_retorno}<br>
            <b>HORAS:</b>  <br>${permiso.hora_desde} - ${permiso.hora_hasta}<br>
            <br>
            Saludos cordiales.`;
        asunto = "NOTIFICACIÓN APROBACIÓN DE PERMISO";
      } else {
        mensaje = `
            <h1>NOTIFICACIÓN SOLICITUD DE PERMISO</h1>
            Estimado(a): ${destinatario.nombres}<br>El motivo de la presente es para informarle que se le envio una solicitud de permiso con los siguientes datos:<br>
            <b>NOMBRE SOLICITANTE:</b>  <br>${permiso.nombres}<br>
            <b>TIPO DE PERMISO:</b>  <br>${permiso.tipo_permiso}<br>
            <b>NRO PAPELETA:</b>  <br>${permiso.numero}<br>
            <b>FECHA DE SOLICITUD:</b>  <br>${permiso.fecha_emision}<br>
            <b>FECHA SALIDA - FIN:</b>  <br>${permiso.fecha_desde} - ${permiso.fecha_retorno}<br>
            <b>HORAS:</b>  <br>${permiso.hora_desde} - ${permiso.hora_hasta}<br>
            <br>
            Ingrese al sistema para APROBAR o RECHAZAR EL PERMISO <br>
            Saludos cordiales.`;
        asunto = "NOTIFICACIÓN SOLICITUD DE PERMISO";
      }
      await this.$service.sendEmail({
        correo: destinatario.correo,
        asunto: asunto,
        mensaje: mensaje.replace(/<[^>]+>/g, ""),
        html: mensaje
      });
    },
    async cargarDetallesPermiso() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
			    query{
					vPermisosPorFuncionarios(id_permiso:"${this.permiso.id_permiso}"){
					rows{
						id_permiso
							id_persona
							nombres
							numero
							fecha_desde
							fecha_emision
							tipo_permiso
							fecha_retorno
							estado_permiso
							nro_dias
							hora_desde
							hora_hasta
							id_lugar
							lugar_atencion
							fecha_nac_muerte
							hora_nac_muerte
							tipo_nac_muerte
							rango_horario
							rechazo
							horas_permiso
							id_tipo_permiso
							compensa_tolerancia
							permiso{
							id
							motivo
							id_tipo_permiso
							ruta_archivo
							tipo_permiso{
								id
								id_parametro_elaborado
							}
							fecha_permiso
							numero
							fecha_registro
							id_estado
							lugar        
							
							estado{
								descripcion
							}
							
							
							}
						}
			}
				}
              `
        });
        this.permiso_detalles2 = respuesta.vPermisosPorFuncionarios.rows;
      } catch (error) {
        console.log(error);
      }
    },
    async total_horas() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta:"select control.fn_total_horas_compensacion(${this.permiso.id_permiso})"){
                    respuesta
                  }
                }	

              `
        });
        if (
          respuesta.runQuery.respuesta[0].fn_total_horas_compensacion == null ||
          respuesta.runQuery.respuesta[0].fn_total_horas_compensacion ==
            undefined
        ) {
          this.total_horas_acomuladas = 0;
        } else {
        }
        let resp = respuesta.runQuery.respuesta[0].fn_total_horas_compensacion;
        this.total_horas_acomuladas = resp;
      } catch (error) {
        console.log(error);
      }
    },
    async verPermisosCompensacion(id_permiso) {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                               query{
                                    runQuery(consulta:"select * from control.fn_permiso_compensa_datos(${id_permiso}) AS datos"){
                                  respuesta
                                }
                            }
                            `
        });

        this.permiso_compensacion = respuesta.runQuery.respuesta;
        this.sumar_horas_compensa(this.permiso_compensacion);
      } catch (error) {
        console.log(error);
      }
    },
    sumar_horas_compensa(permiso_detalles) {
      let total_comp = 0;
      permiso_detalles.forEach(item => {
        total_comp +=
          this.$moment(item.fecha_hasta + " " + item.hora_hasta).diff(
            item.fecha_desde + " " + item.hora_desde,
            "minutes"
          ) / 60;
      });
      this.horas_solicitadas_comp = total_comp;
    },
    close() {
      this.dialog = false;
      this.permiso = {
        motivo: ""
      };
      this.$bus.$emit("closeDialog");
    },

    sumar_horas(permiso_detalles) {
      let total = 0;
      permiso_detalles.forEach(item => {
        total +=
          this.$moment(item.fecha_hasta + " " + item.hora_hasta).diff(
            item.fecha_desde + " " + item.hora_desde,
            "minutes"
          ) / 60;
      });
      this.horas_solicitadas = total;
    },
    getUserId() {
      const user = this.$storage.get("user");
      return user.id_persona;
    },
    async getDetallePermiso(id) {
      try {
        let res = await this.$service.graphql({
          query: `
              query{
              vDetallePermisos(lista_estados:"9,6,7,16,21",id_permiso:${id}){
                rows{
                  id
                  id_permiso
                  id_estado_detalle
                  fecha_desde
                  fecha_hasta
                  fecha_desde_compensa
                  hora_desde
                  hora_hasta
                  horas_compensa
                  fecha_permiso
				  total_dias
				  rango_horario
                }
              }
          }
          `
        });
        this.permiso_detalles = res.vDetallePermisos.rows;

        this.sumar_horas(this.permiso_detalles);
      } catch (error) {
        console.log(error);
      }
    },
    async getDetalleSeguimiemto(id) {
      try {
        let respuesta;
        let res;
        respuesta = await this.$service.graphql({
          query: `
                               query{
                                    runQuery(consulta:"SELECT * FROM control.v_seguimiento_detalle_historico vd where vd.id=(${id}) order by vd.id_seguimiento desc"){
                                  respuesta
                                }
                            }
                            `
        });

        respuesta = respuesta.runQuery.respuesta;
        //obtener el nuevo seguimiento
        res = await this.$service.graphql({
          query: `
                query{
      			      vSeguimientoDetalles(id:${id}){
          			    rows{
						          fecha_registro
            			    estado
            			    usuario
                      jefe
                      id_estado
                      motivo
                      jefe
                      }
                  }
              }

          `
        });
        res = res.vSeguimientoDetalles.rows;
        this.detalle_seguimiento = res.concat(respuesta);
      } catch (error) {
        console.log(error);
      }
    },
    async apruebaRechazaPermiso(permiso, id_estado) {
      const user = this.$storage.get("user");
      const permiso_copia = JSON.parse(JSON.stringify(this.permiso));
      permiso_copia.hora_desde = this.permiso_detalles2[0].hora_desde;
      permiso_copia.hora_hasta = this.permiso_detalles2[0].hora_hasta;
      let respuesta = "";
      if (this.permiso.id_tipo_permiso == 87) {
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_aprueba_permiso_oficial(${permiso.id_permiso},'${id_estado}',${user.id_persona},'${user.id}','${permiso.motivo_rechazo}')"){
                  respuesta
                }
              }
            `
          });

          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_permiso_oficial;
          let resps2 = resp.split("|");
          let correcto = resps2[0];
          if (correcto == "1") {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }

      if (this.permiso.id_tipo_permiso == 96) {
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_aprueba_permiso_oficial(${permiso.id_permiso},'${id_estado}',${user.id_persona},'${user.id}','${permiso.motivo_rechazo}')"){
                  respuesta
                }
              }
            `
          });

          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_permiso_oficial;
          let resps2 = resp.split("|");
          let correcto = resps2[0];
          if (correcto == "1") {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }

///WC
if (this.permiso.id_tipo_permiso == 104) {
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_aprueba_permiso_oficial(${permiso.id_permiso},'${id_estado}',${user.id_persona},'${user.id}','${permiso.motivo_rechazo}')"){
                  respuesta
                }
              }
            `
          });

          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_permiso_oficial;
          let resps2 = resp.split("|");
          let correcto = resps2[0];
          if (correcto == "1") {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (this.permiso.id_tipo_permiso == 103) {
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_aprueba_permiso_oficial(${permiso.id_permiso},'${id_estado}',${user.id_persona},'${user.id}','${permiso.motivo_rechazo}')"){
                  respuesta
                }
              }
            `
          });

          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_permiso_oficial;
          let resps2 = resp.split("|");
          let correcto = resps2[0];
          if (correcto == "1") {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }


      if (this.permiso.id_tipo_permiso == 89) {
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_aprueba_permiso_oficial(${permiso.id_permiso},'${id_estado}',${user.id_persona},'${user.id}','${permiso.motivo_rechazo}')"){
                  respuesta
                }
              }
            `
          });

          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_permiso_oficial;
          let resps2 = resp.split("|");
          let correcto = resps2[0];
          if (correcto == "1") {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }


      if (this.permiso.id_tipo_permiso == 102) {
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_aprueba_horario_continuo(${permiso.id_permiso},${id_estado},${user.id_persona},'${user.id}')"){
                  respuesta
                }
              }
            `
          });

          let resp =
            respuesta.runQuery.respuesta[0].fn_aprueba_horario_continuo;
          let resps2 = resp.split("|");
          let correcto = resps2[0];
          if (correcto == "1") {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (this.permiso.id_tipo_permiso == 6) {
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_aprueba_duelo(${permiso.id_permiso},7,${user.id_persona},'${user.id}','${permiso.motivo_rechazo}')"){
                  respuesta
                }
              }
            `
          });
          console.log(respuesta.runQuery.respuesta[0].fn_aprueba_duelo);
          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_duelo;
          let resps2 = resp.split("|");

          let correcto = resps2[0];
          if (correcto == "1") {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (this.permiso.id_tipo_permiso == 61) {
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_aprueba_paternidad(${permiso.id_permiso},'${id_estado}',${user.id_persona},'${user.id}','${permiso.motivo_rechazo}')"){
                  respuesta
                }
              }
            `
          });

          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_paternidad;
          let resps2 = resp.split("|");

          let correcto = resps2[0];
          if (correcto == "1") {
            this.$confirm("Operación realizada correctamente", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (this.permiso.id_tipo_permiso == 88) {
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_aprueba_permiso_oficial(${permiso.id_permiso},'${id_estado}',${user.id_persona},'${user.id}','${permiso.motivo_rechazo}')"){
                  respuesta
                }
              }
            `
          });

          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_permiso_oficial;
          let resps2 = resp.split("|");

          let correcto = resps2[0];
          if (correcto == "1") {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }

      if (this.permiso.id_tipo_permiso == 14) {
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_aprueba_lic_personal(${permiso.id_permiso},'${id_estado}',${user.id_persona},'${user.id}','')"){
                  respuesta
                }
              }
            `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_lic_personal;
          let resps = resp.split("|");
          let correcto = resps[0];
          if (correcto == 1) {
            this.$alert("El permiso fue aprobado", () => {});
            this.close();
          } else {
            this.$alert(resps[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }


      if (this.permiso.id_tipo_permiso == 105) {
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_aprueba_lic_personal(${permiso.id_permiso},'${id_estado}',${user.id_persona},'${user.id}','')"){
                  respuesta
                }
              }
            `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_lic_personal;
          let resps = resp.split("|");
          let correcto = resps[0];
          if (correcto == 1) {
            this.$alert("El permiso fue aprobado", () => {});
            this.close();
          } else {
            this.$alert(resps[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }



      if (this.permiso.id_tipo_permiso == 24) {
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_aprueba_cta_vacacion(${permiso.id_permiso},'${id_estado}','${user.id_persona}','${user.id}')"){
                  respuesta
                }
              }
            `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_cta_vacacion;
          let resps = resp.split("|");
          let correcto = resps[0];
          if (correcto == "1") {
            this.$alert("El permiso fue aprobado", () => {});
            this.close();
          } else {
            this.$alert(resps[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (this.permiso.id_tipo_permiso == 94) {
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_aprueba_permiso_oficial(${permiso.id_permiso},'${id_estado}',${user.id_persona},'${user.id}','')"){
                  respuesta
                }
              }
            `
          });

          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_permiso_oficial;
          let resps2 = resp.split("|");

          let correcto = resps2[0];
          if (correcto == "1") {
            this.$alert("El permiso fue aprobado", () => {});
            this.close();
          } else {
            this.$alert(resps2[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      //CJTO DE PERMISOS TOLERANCIA
      if (
        this.permiso.id_tipo_permiso >= 37 &&
        this.permiso.id_tipo_permiso <= 43
      ) {
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_aprueba_pap_pros (${permiso.id_permiso},${id_estado},${user.id},'')"){
                  respuesta
                }
              }
            `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_pap_pros;
          let resps2 = resp.split("|");
          let correcto = resps2[0];
          if (correcto == "1") {
            this.$alert("El permiso fue aprobado", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }

      if (this.permiso.id_tipo_permiso == 12) {
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{
                  runQuery(consulta:"select control.fn_aprueba_rechaza_permiso_matrimonio_superior(${permiso.id_permiso},'${id_estado}','${user.id}',${user.id_persona})"){
                  respuesta
                }
              }
            `
          });
          let resp =
            respuesta.runQuery.respuesta[0]
              .fn_aprueba_rechaza_permiso_matrimonio_superior;
          let resps = resp.split("|");
          let correcto = resps[0];

          if (resps[0] == "1" && id_estado == 7) {
            this.$alert("El permiso fue aprobado", () => {});
            this.close();
          }
          if (resps[0] == "1" && id_estado == 16) {
            this.$alert("El permiso fue rechazado", () => {});
            this.close();
          }

          if (resps[0] == "0") {
            this.$confirm(resps[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }


      


      // ENVIO DE CORREO
      await this.enviarCorreoDestinatario(permiso_copia);
      this.close();
    }
  }
};
</script>
<style scoped>
.texto-aprobar {
  font-size: 1.3rem;
  color: rgb(24, 106, 121);
  margin: 0 !important;
}
.subtitulo-aprobar {
  font-size: 1.35em;
  color: rgb(24, 106, 121);
  font-weight: bolder;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/permiso/dialogs/AprobarPermisoOficialPorHoras.vue